import { useMutation, useQuery } from "@apollo/client/react";
import paths from "config/routePaths";
import { DeleteCompany, GetAllCompanies, GetCompany, UpdateCompany } from "hooks/apollo/company/company.gql";
import useGoBack from "hooks/useGoBack";
import Authorization from "policies/Authorization";
import React from "react";
import CompanyEditView from "./CompanyEditView";

export default function CompanyEditContainer({ id }) {
  const { goBack } = useGoBack();
  const policy = Authorization.usePolicy();
  const leavePage = () => {
    goBack(paths.companyIndex);
  };
  const [updateCompany] = useMutation(UpdateCompany, { onCompleted: () => leavePage() });
  const [deleteCompany] = useMutation(DeleteCompany, { onCompleted: () => leavePage() });

  const { data, loading } = useQuery(GetCompany, { variables: { id } });

  if (loading) return null;

  const handleCancel = () => leavePage();

  const handleSave = (args) => {
    const defaultCompany = {
      name: "",
    };

    const company = { ...defaultCompany, ...data?.company, ...args };

    return updateCompany({ refetchQueries: [{ query: GetAllCompanies }], variables: company });
  };

  const handleDelete = (event) => {
    event.preventDefault();
    deleteCompany({ refetchQueries: [{ query: GetAllCompanies }], variables: { id } });
  };

  const canCreateSite = policy.canCreate(Authorization.EntityTypes.Site);
  const canCreateUser = policy.canCreate(Authorization.EntityTypes.User);
  const canUpdateCompany = policy.canUpdate(Authorization.EntityTypes.Company);
  const createSitePath = paths.siteNewForCompany(id);
  const createUserPath = paths.userNewForCompany(id);

  return (
    <CompanyEditView
      canCreateSite={canCreateSite}
      canCreateUser={canCreateUser}
      canUpdateCompany={canUpdateCompany}
      company={data?.company}
      createSitePath={createSitePath}
      createUserPath={createUserPath}
      onCancel={handleCancel}
      onDelete={handleDelete}
      onSave={handleSave}
    />
  );
}
